import { ReactElement } from 'react';
import { TotalItem } from 'devextreme-react/data-grid';
import React from 'react';
import { conditionalTwoDigitSummaryCurrency } from './constants/constants';

interface IDrawManualInspectionTotalItemsProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    toggleArray: [];
}

export const DrawManualInspectionTotalItems = ({
    drawId,
    drawNumber,
    drawFinalized,
    toggleArray,
}: IDrawManualInspectionTotalItemsProps): ReactElement[] => {
    if (toggleArray[drawNumber] === true) {
        return [
            <TotalItem
                name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            <TotalItem
                name={`drawItems-inspection-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-inspection-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            // <TotalItem
            //     name={`OutOfBalance${drawId}-${drawNumber}`}
            //     showInColumn={`OutOfBalance${drawId}-${drawNumber}`}
            //     summaryType='custom'
            //     customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            // />,
        ];
    } else {
        if (drawFinalized) {
            return [
                <TotalItem
                    name={`drawItems-funded-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
                />,
            ];
        } else {
            return [
                <TotalItem
                    name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
                />,
            ];
        }
    }
};
